import {
  Checkbox,
  DatePicker,
  Input,
  InputNumber,
  Radio,
  Rate,
  Select,
  Switch,
  TimePicker,
  Typography,
  Upload,
} from 'antd';

export const FormElements = new Map([
  [
    'string',
    {
      label: 'Text Input',
      type: 'input',
      component: Input,
    },
  ],
  [
    'email',
    {
      label: 'Email Input',
      type: 'input',
      component: Input,
    },
  ],
  [
    'number',
    {
      label: 'Number Input',
      type: 'input',
      component: InputNumber,
    },
  ],
  [
    'text',
    {
      label: 'Text Area',
      type: 'input',
      component: Input.TextArea,
    },
  ],
  [
    'date',
    {
      label: 'Date',
      type: 'date',
      component: DatePicker,
    },
  ],
  [
    'time',
    {
      label: 'Time',
      type: 'time',
      component: TimePicker,
    },
  ],
  [
    'select',
    {
      label: 'Select',
      type: 'select',
      withOptions: true,
      component: Select,
    },
  ],
  [
    'boolean',
    {
      label: 'Boolean',
      type: 'boolean',
      component: Switch,
    },
  ],
  [
    'Checkbox.Group',
    {
      label: 'Checkboxes',
      type: 'checkboxes',
      withOptions: true,
      component: Checkbox.Group,
    },
  ],
  [
    'Checkbox',
    {
      label: 'Checkbox',
      type: 'checkbox',
      component: Checkbox,
    },
  ],
  [
    'Radio.Group',
    {
      label: 'Multiple Choice',
      type: 'radio',
      withOptions: true,
      component: Radio.Group,
    },
  ],
  [
    'FileUpload',
    {
      label: 'File Upload',
      type: 'upload',
      component: Upload,
    },
  ],
  [
    'Rate',
    {
      label: 'Rate',
      type: 'rate',
      component: Rate,
    },
  ],
  [
    'Header',
    {
      label: 'Header Text',
      type: 'text',
      component: Typography.Title,
    },
  ],
  [
    'Label',
    {
      label: 'Label Text',
      type: 'text',
      component: Typography.Text,
    },
  ],
]);
